// extracted by mini-css-extract-plugin
module.exports = {"menuItems":"DesktopProfileMenu_menuItems__T0tPp"};